/**
 * Take Quiz page - interactive quiz taking
 */

import React from 'react';
import { useParams, Link } from 'react-router-dom';
import QuizTaker from '../components/QuizTaker';
import './take.css';

export default function TakeQuiz() {
    const { id } = useParams<{ id: string }>();
    const quizId = Number(id);

    return (
        <main className="takeQuizMain">
            <div className="takeQuizHeader">
                <Link to="/" className="backLink">
                    ← Back to Quizzes
                </Link>
            </div>
            <QuizTaker quizId={quizId} />
        </main>
    );
}
